import saveAs from "file-saver";
import { openapi } from "../../../../openapi";
import { setShowFailedMessageThunk, setShowSuccessMessageThunk } from "../../../global/globalSlice";
import "./checklistapi.enhance";

const base64ToBlob = (base64: string, mime: string): Blob => {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let index = 0; index < bin.length; index++) {
    bytes[index] = bin.charCodeAt(index);
  }
  return new Blob([bytes], { type: mime });
};

openapi.enhanceEndpoints({
  endpoints: {
    postProjectByProjectIdChecklistUpdateRowPosition: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("Sjekkliste oppdatert"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved flytting av rad"));
        }
      },
    },
    putProjectByProjectIdChecklistAndChecklistIdUpdateChecklistIds: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("ID-sekvenser tilbakestilt"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved tilbakestilling av ID-sekvenser"));
        }
      },
    },
    postProjectByProjectIdChecklistAndChecklistIdCategory: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("Sjekkliste oppdatert"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved oppretting av kategori"));
        }
      },
    },
    postProjectByProjectIdChecklistAndChecklistIdItem: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("Sjekkliste oppdatert"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved oppretting av rad"));
        }
      },
    },
    deleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryId: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("Sjekkliste oppdatert"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved sletting av kategori"));
        }
      },
    },
    deleteProjectByProjectIdChecklistAndChecklistIdItemItemId: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(setShowSuccessMessageThunk("Sjekkliste oppdatert"));
        } catch {
          dispatch(setShowFailedMessageThunk("Feil ved sletting av rad"));
        }
      },
    },
    postChecklistIntegrationGenerate: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          saveAs(base64ToBlob(data.base64, data.mime), data.filename);
        } catch {
          dispatch(
            setShowFailedMessageThunk(
              "Noe gikk galt ved generering av sjekkliste-DOCX. Prøv igjen, eller kontakt support hvis problemet vedvarer.",
            ),
          );
        }
      },
    },
  },
});
